import * as React from 'react';
import { ConditionalWrapper } from '@cian/conditional-component';
import { path } from 'ramda';
import { questionsMapper } from './constants/questionsMapper';
import { formContextObj } from './context';
import { QuestionSwitchAnim } from '../../components/QuestionSwitchAnim';
import { useDeviceType } from '@cian/ui-kit';

export const FormContainer: React.FC = () => {
  const {
    currentQuestion,
    setNextStep,
    setAnswer,
    answersState,
    setAnswersState,
    registerBackInterceptor,
    unRegisterBackInterceptor,
    isSetPrev,
  } = React.useContext(formContextObj);
  const deviceType = useDeviceType();

  const QuestionComponent = questionsMapper(
    currentQuestion.code,
    currentQuestion.type,
    currentQuestion.answerType,
    path(['extras', 'isLast'], currentQuestion),
  );

  return (
    <ConditionalWrapper
      if={deviceType !== 'desktop'}
      thenRender={child => (
        <QuestionSwitchAnim questionKey={currentQuestion.code} isSetPrev={isSetPrev} children={child} />
      )}
    >
      <QuestionComponent
        question={currentQuestion}
        setAnswer={setAnswer}
        answersState={answersState}
        setNextStep={setNextStep}
        registerBackInterceptor={registerBackInterceptor}
        unRegisterBackInterceptor={unRegisterBackInterceptor}
        setAnswersState={setAnswersState}
      />
    </ConditionalWrapper>
  );
};

FormContainer.displayName = 'FormContainer';
